import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IntegracionServices extends HttpClientBase {
    constructor(http: HttpClient) {
        super(http, 'integraciones'); // La URL base para el servicio de lotes
    }

    getPrecargarCalibraciones(id: string): Observable<any> {
        return this.get<any>({ endpoint: `calibraciones/precargar/${id}` });
    }

    getUrlCordenada(id: string, id_url: number): Observable<any> {
        return this.get<any>({ endpoint: `calibraciones/precargar/${id}/url/${id_url}/coordenadas` });
    }

    getObtenerCoordenada(id: string, id_url: string){
        
        return this.get<any>({ endpoint: `calibraciones/precargar/${id}/url/${id_url}/coordenadas` })
    }


    createCoordenadas(id: string, id_url: string, body: any, trackLoading = true) {
        return this.post(body, `/calibraciones/precargar/${id}/url/${id_url}/coordenadas`, undefined, trackLoading);
    }

    deleteCoordenada(id: string, id_url: string, id_coordenada: string) {
        return this.delete<any>(`calibraciones/precargar/${id}/url/${id_url}/coordenadas/${id_coordenada}`);
    }

    saveSistemaExterno(body: any, nombre_corto: string, trackLoading = true) {
        return this.post(body, `/sistemas/${nombre_corto}/enviar`, undefined, trackLoading);
    }

    pruebaConexion(nombre_corte: string, trackLoading = true){
        return this.post(null, `sistemas/${nombre_corte}/login`, undefined, trackLoading);
    }

    createPlatillaExterna(id: string, trackLoading = true) {
        return this.post(null, `calibraciones/precargar/${id}/plantillas`, undefined, trackLoading);
    }

    creadencialesCache(nombre_corto: string, trackLoading = true) {
        return this.post(null, `sistemas/${nombre_corto}/filesystems/credenciales/cache`, undefined, trackLoading);
    }


}